import { render, staticRenderFns } from "./enrollDetail.vue?vue&type=template&id=2206f2f0&scoped=true"
import script from "./enrollDetail.vue?vue&type=script&lang=js"
export * from "./enrollDetail.vue?vue&type=script&lang=js"
import style0 from "../../assets/css/enroll/enrollDetail.css?vue&type=style&index=0&id=2206f2f0&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2206f2f0",
  null
  
)

export default component.exports